import styled from "styled-components";

export default styled.div<{ url: string }>`
  background-size: cover;
  background-position: center;
  background-image: url(${({ url }) => url});
`;
